<template>
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/banner_bg.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
    v-if="
      currentGameSlug !== 'ow-boost' && currentGameSlug !== 'call-of-duty-boost'
    "
  />
  <LazyLolBoosting
    v-if="$route.params.gameSlug === 'league-of-legends-boost'"
  />
  <LazyValBoosting v-else-if="$route.params.gameSlug === 'valorant-boost'" />
  <LazyRainbowBoosting
    v-else-if="$route.params.gameSlug === 'rainbow-six-siege-boost'"
  />
  <LazyOverwatchBoosting v-else-if="$route.params.gameSlug === 'ow-boost'" />
  <LazyTeamfightBoosting
    v-else-if="$route.params.gameSlug === 'teamfight-tactics-boost'"
  />
  <LazyRocketBoosting
    v-else-if="$route.params.gameSlug === 'rocket-league-boost'"
  />
  <LazyCs2Boosting
    v-else-if="$route.params.gameSlug === 'counter-strike-2-boost'"
  />
  <LazyTheFinalsBoosting
    v-else-if="$route.params.gameSlug === 'the-finals-boost'"
  />
  <LazyApexLegendsBoosting
    v-else-if="$route.params.gameSlug === 'apex-legends-boost'"
  />
  <LazyDotaBoosting v-else-if="$route.params.gameSlug === 'dota-2-boost'" />
  <LazyFortniteBoosting
    v-else-if="$route.params.gameSlug === 'fortnite-boost'"
  />
  <LazyCodBoosting
    v-else-if="$route.params.gameSlug === 'call-of-duty-boost'"
  />
  <LazyMarvelRivalsBoosting
    v-else-if="$route.params.gameSlug === 'marvel-rivals-boost'"
  />
</template>

<script setup>
import LazyLolBoosting from "./games/LolBoosting.vue";
import LazyValBoosting from "./games/ValorantBoosting.vue";
import LazyRainbowBoosting from "./games/RainbowBoosting.vue";
import LazyOverwatchBoosting from "./games/OverwatchBoosting.vue";
import LazyTeamfightBoosting from "./games/TftBoosting.vue";
import LazyRocketBoosting from "./games/RLBoosting.vue";
import LazyDotaBoosting from "./games/DotaBoosting.vue";
import LazyCs2Boosting from "./games/Cs2Boosting.vue";
import LazyTheFinalsBoosting from "./games/TheFinalsBoosting.vue";
import LazyApexLegendsBoosting from "./games/ApexLegendsBoosting.vue";
import LazyFortniteBoosting from "./games/FortniteBoosting.vue";
import LazyCodBoosting from "./games/CodBoosting.vue";
import LazyMarvelRivalsBoosting from "./games/MarvelRivalsBoosting.vue";

const { currentGameSlug } = useGameComposable();
</script>
